export const CLIENT_CONTACTS_EDIT_MODAL_NAME = 'clientContactsEdit';
